export { default as NotAffiliationFinalized } from './not-affiliation-finalized';
export { default as SaveAfiliation } from './save-afiliation';
export { default as CloseSessionModal } from './close-session-modal';

export { default as Loader } from './loader';


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/index.js
// module id = ./src/components/modals/index.js
// module chunks = 34